/** Uno - Planner browser cache async storage prefix */ export const PlannerAsyncStoragePrefix = "Planner";
/** Evo - Planner browser cache async storage prefix */ export const PlannerV2AsyncStoragePrefix = "PlannerV2";
/** Key for storing ViewStore ViewConfig data in localStorage (array order = LRU order, index 0 = most recent) */ export const ViewStoreViewConfigKey = "vstore-vconfig";
/** Key for storing the global task editor render mode preference in localStorage */ export const ViewStoreTaskEditorRenderModeKey = "vstore-task-editor-render-mode";
/**
 * Evo - Planner browser cache async storage schema version
 */ export const PlannerV2AsyncStorageSchemaVersionV1 = 2;
/** Uno - Planner browser cache async storage schema version V1
 * This version is used for shipping Mru store persistence - mru items and collection status
 */ export const PlannerAsyncStorageSchemaVersionV1 = 1;
/** Uno - Planner browser cache async storage schema version V2
 * This is the latest supported schema version.
 */ export const PlannerAsyncStorageSchemaVersionV2 = 3;
export var PlannerPersistedObjectStoreKeys;
(function(PlannerPersistedObjectStoreKeys) {
    PlannerPersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PlannerPersistedObjectStoreKeys["Plans"] = "id";
    PlannerPersistedObjectStoreKeys["Buckets"] = "id";
    PlannerPersistedObjectStoreKeys["Tasks"] = "id";
    PlannerPersistedObjectStoreKeys["Status"] = "key";
    PlannerPersistedObjectStoreKeys["Goals"] = "id";
    PlannerPersistedObjectStoreKeys["ViewConfig"] = "viewId";
})(PlannerPersistedObjectStoreKeys || (PlannerPersistedObjectStoreKeys = {}));
export var PlannerPersistedObjectStoreIndexNames;
(function(PlannerPersistedObjectStoreIndexNames) {
    PlannerPersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PlannerPersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PlannerPersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PlannerPersistedObjectStoreIndexNames["TasksAssigneeIdentityIdIndex"] = "assigneeIdentityIds";
    PlannerPersistedObjectStoreIndexNames["GoalsPlanIndex"] = "planId";
})(PlannerPersistedObjectStoreIndexNames || (PlannerPersistedObjectStoreIndexNames = {}));
export var PersistedObjectStoreKeys;
(function(PersistedObjectStoreKeys) {
    PersistedObjectStoreKeys["Mru"] = "server_doc_id";
    PersistedObjectStoreKeys["Plans"] = "id";
    PersistedObjectStoreKeys["Buckets"] = "id";
    PersistedObjectStoreKeys["Tasks"] = "id";
    PersistedObjectStoreKeys["Status"] = "key";
})(PersistedObjectStoreKeys || (PersistedObjectStoreKeys = {}));
export var PersistedObjectStoreIndexNames;
(function(PersistedObjectStoreIndexNames) {
    PersistedObjectStoreIndexNames["MruPinnedIndex"] = "isPinnedString";
    PersistedObjectStoreIndexNames["BucketsPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksPlanIndex"] = "planId";
    PersistedObjectStoreIndexNames["TasksMyDayDateIndex"] = "myDayDate";
    PersistedObjectStoreIndexNames["TasksAssignmentsIndex"] = "assigneeIds";
})(PersistedObjectStoreIndexNames || (PersistedObjectStoreIndexNames = {}));
/**
 * localStorage key used by the old MyTasks new-experience toggle.
 * Read once during bootstrap to migrate the user's preference into the URL, then removed.
 */ export const NewMyTasksExperienceLocalStorageKey = "planner_useNewMyTasksExperience";
